module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-10-sm-816cbab27b709debdce2309d9b2e8b7a.png";